module.exports = __webpack_public_path__ + "img/02-HIW-m.aea99a48.png";